// extracted by mini-css-extract-plugin
export default {"screenContainer":"styles_screenContainer__yCVQc"};